import { Route, Routes } from 'react-router-dom';
import VendorList from 'routes/admin/account/VendorList';
import VendorRegister from 'routes/admin/account/VendorRegister';
import AdminCategoryList from 'routes/admin/category/AdminCategoryList';
import AutoOrdering from 'routes/admin/order/auto/AutoOrdering';
import VendorOrderRequestList from 'routes/admin/orderRequest/VendorOrderRequestList';
import AdminProductList from 'routes/admin/product/AdminProductList';
import AdminProductRegister from 'routes/admin/product/AdminProductRegister';
import VendingDetail from 'routes/admin/vending/VendingDetail';
import VendingManagement from 'routes/admin/vending/VendingManagement';
import VendingRegister from 'routes/admin/vending/VendingRegister';
import TestPage from 'routes/front/test/TestPage';
import MokStdRedirect from 'routes/front/test/mok/MokStdRedirect';
import MokStdRequest from 'routes/front/test/mok/MokStdRequest';

import ManagerLayout from 'routes/manager/ManagerLayout';

import AdminCategoryCreate from 'routes/admin/category/AdminCategoryCreate';
import AdminCategoryRegister from 'routes/admin/category/AdminCategoryRegister';
import AdminStoreRegister from 'routes/admin/store/AdminStoreRegister';
import StoreManagement from 'routes/admin/store/StoreManagement';
import VendingMapping from 'routes/admin/vending/VendingMappaing';
import RequireAuth from 'shared/utils/RequireAuth';
import StoreManagementDetail from 'routes/admin/store/StoreManagementDetail';
import MachineManagement from 'routes/admin/store/MachineManagement';
import AdminMobileStartPage from 'routes/adminMobile/pages/AdminMobileStartPage';
import AdminMobileMainPage from 'routes/adminMobile/pages/AdminMobileMainPage';
import AdminMobileLayout from 'routes/adminMobile/layouts/AdminMobileLayout';
import AdminMobileStoreSale from 'routes/adminMobile/pages/AdminMobileStoreSale';
import AdminMobileStoreProduct from 'routes/adminMobile/pages/AdminMobileStoreProduct';
import AdminMobileStoreEvent from 'routes/adminMobile/pages/AdminMobileStoreEvent';
import AdminMobileStoreNotice from 'routes/adminMobile/pages/AdminMobileStoreNotice';
import AdminMobileStoreSearch from 'routes/adminMobile/pages/AdminMobileStoreSearch';
import AdminMobileProductRegister from 'routes/adminMobile/pages/AdminMobileProductRegister';
import AdminMobileCategory from 'routes/adminMobile/pages/AdminMobileCategory';
import AdminMobileCateRegister from 'routes/adminMobile/pages/AdminMobileCateRegister';
import AdminMobileUser from 'routes/adminMobile/pages/AdminMobileUser';
import AdminMobileUserRegister from 'routes/adminMobile/pages/AdminMobileUserRegister';
import AdminMobileMachine from 'routes/adminMobile/pages/AdminMobileMachine';
import AdminMobileStats from 'routes/adminMobile/pages/AdminMobileStats';
import AdminMobileStatsDetail from 'routes/adminMobile/pages/AdminMobileStatsDetail';
import AdminMobileOrder from 'routes/adminMobile/pages/AdminMobileOrder';
import AdminMobileOrderDetail from 'routes/adminMobile/pages/AdminMobileOrderDetail';
import AdminMobileNoticeRegister from 'routes/adminMobile/pages/AdminMobileNoticeRegister';
import AdminMobileEventRegister from 'routes/adminMobile/pages/AdminMobileEventRegister';
import AdminProductDetail from 'routes/admin/product/AdminProductDetail';
import StoreConfirmYnManagement from 'routes/admin/store/StoreConfirmYnManagement';
import VideoPlayer from 'routes/video/VideoPlayer';
import BrandRegistration from 'routes/admin/brand/BrandRegistration';
import BrandList from 'routes/admin/brand/BrandList';
import BrandListDetail from 'routes/admin/brand/BrandListDetail';
import ExhibitionRegistration from 'routes/admin/exhibition/ExhibitionRegistration';
import ExhibitionList from 'routes/admin/exhibition/ExhibitionList';
import AdminIot from 'routes/admin/iot/AdminIot';
import VendorInquireList from 'routes/admin/account/VendorInquireList';
import AdminMobileNoticeUpdate from 'routes/adminMobile/pages/AdminMobileNoticeUpdate';
import AdminNewDashboard from 'routes/admin/dashboard/AdminNewDashboard';
import CCTVMonitor from 'routes/admin/cctv/CCTVMonitor';
import AdminStoreEdit from 'routes/admin/store/AdminStoreEdit';
import PartnersRegister from 'routes/admin/partners/PartnersRegister';
import SalesRateManagement from 'routes/admin/vendor/sales/SalesRateManagement';
import AdminVerificationStats from 'routes/admin/verificationStats/AdminVerificationStats';
import SettlementPage from 'routes/admin/settlement/SettlementPage';
import DetailedSettlementPage from 'routes/admin/settlement/DetailedSettlementPage';
import StoreStockManagement from 'routes/admin/store/StoreStockManagement';
import StoreSelection from 'routes/admin/store/StoreSelection';
import VideoUploadTestPage from 'routes/front/test/VideoUploadTestPage';
import PdfSigner from 'components/contract/PdfSigner';
import ContractTemplateUpload from 'routes/front/test/ContractTemplateUpload';
import SignedPdfViewer from 'components/contract/SignedPdfViewer';

function AdminRouter({ allowedRoles }) {
    const storeId = 'root';
    return (
        <Routes>
            <Route
                path=""
                element={<RequireAuth allowedRoles={allowedRoles} />}
            >
                {/* <Route path="" element={<RequireAuth allowedRoles={allowedRoles} />}> */}
                {/* <Route path="builder" element={<BuilderLayout storeId={storeId}/>}>              
                </Route> */}

                {/* 이건정 라우터 추가 */}
                {/* 본사 관리자 모바일 시작 화면 */}
                <Route path="mobile/start" element={<AdminMobileStartPage />} />
                {/* 상품 등록 페이지 */}
                <Route path="mobile/product/register" element={<AdminMobileProductRegister />} />
                {/* 카테고리 등록 페이지 */}
                <Route path="mobile/storeCate/register" element={<AdminMobileCateRegister />} />
                {/* 유저 등록 페이지 */}
                <Route path="mobile/user/register" element={<AdminMobileUserRegister />} />
                {/* 공지 등록 페이지 */}
                <Route path="mobile/notice/register" element={<AdminMobileNoticeRegister />} />
                {/* 공지 수정 페이지 */}
                <Route path="mobile/notice/update" element={<AdminMobileNoticeUpdate />} />
                {/* 이벤트 등록 페이지 */}
                <Route path="mobile/event/register" element={<AdminMobileEventRegister />} />
                {/* 모바일 공통 컨테이너 */}
                <Route path="mobile" element={<AdminMobileLayout />}>
                    {/* 메인 화면 */}
                    <Route path="" element={<AdminMobileMainPage />} />
                    {/* 점포별 매출 현황 */}
                    <Route path="storeSale" element={<AdminMobileStoreSale />} />
                    {/* 상품 관리 */}
                    <Route path="product" element={<AdminMobileStoreProduct />} />
                    {/* 이벤트 관리 */}
                    <Route path="event" element={<AdminMobileStoreEvent />} />
                    {/* 공지 관리 */}
                    <Route path="notice" element={<AdminMobileStoreNotice />} />
                    {/* 가맹점 조회 */}
                    <Route path="storeSearch" element={<AdminMobileStoreSearch />} />
                    {/* 카테고리 관리 */}
                    <Route path="storeCate" element={<AdminMobileCategory />} />
                    {/* 유저 관리 */}
                    <Route path="userManage" element={<AdminMobileUser />} />
                    {/* 자판기 관리 */}
                    <Route path="machManage" element={<AdminMobileMachine />} />
                    {/* 통계 */}
                    <Route path="stats" element={<AdminMobileStats />} />
                    {/* 점포별 통계 */}
                    <Route path="statsDetail/:storeNo" element={<AdminMobileStatsDetail />} />
                    {/* 발주 관리 */}
                    <Route path="order" element={<AdminMobileOrder />} />
                    {/* 점포별 발주 상세내역 */}
                    <Route path="orderDetail/:orderNo" element={<AdminMobileOrderDetail />} />
                </Route>

                <Route path={'test'} element={<TestPage />} />
                <Route path={'mokRedirect'} element={<MokStdRedirect />} />
                <Route path={'mokRequest'} element={<MokStdRequest />} />
                <Route path="" element={<ManagerLayout />}>
                    <Route index element={<AdminNewDashboard />} />
                    <Route path="test6" element={<VideoUploadTestPage />} />
                    <Route path="template" element={<ContractTemplateUpload />} />
                    <Route path="checkPdf" element={<SignedPdfViewer />} />
                    <Route path="verificationStats" element={<AdminVerificationStats />} />
                    <Route path="videoTest" element={<VideoPlayer />} />
                    <Route path="store/register" element={<AdminStoreRegister />} />
                    <Route path="store/management" element={<StoreManagement />} />
                    <Route path="store/management/detail/:storeId/stock" element={<StoreStockManagement />} />
                    <Route path="store/management/edit" element={<AdminStoreEdit />} />
                    <Route path="store/confirmYnManagement" element={<StoreConfirmYnManagement />} />
                    <Route path="store/management/detail" element={<StoreManagementDetail />} />
                    <Route path="store/management/detail/:machineId" element={<MachineManagement />} />
                    <Route path="store/contract" element={<PdfSigner />} />
                    <Route path="product/register" element={<AdminProductRegister />} />
                    <Route path="product/list" element={<AdminProductList />} />
                    <Route path="product/list/:detail" element={<AdminProductDetail />} />
                    <Route path="category/create" element={<AdminCategoryCreate />}
                    />
                    <Route path="settlement" element={<SettlementPage />} />
                    <Route path="detailedSettlement" element={<DetailedSettlementPage />} />

                    <Route path="category/register" element={<AdminCategoryRegister />}
                    />
                    <Route path="category/list" element={<AdminCategoryList />} />
                    <Route path="vendor/register" element={<VendorRegister />} />
                    <Route path="vendor/list" element={<VendorList />} />
                    <Route path="vendor/salesRate" element={<SalesRateManagement />} />
                    <Route path="vendor/inquire/list" element={<VendorInquireList />} />
                    {/* <Route path="vendor/orderRequests" element={<VendorOrderRequestList />} /> */}
                    {/* <Route path="vendor/autoOrdering" element={<AutoOrdering />} /> */}
                    <Route path="vending/list" element={<VendingManagement />} />
                    <Route path="vending/list/detail" element={<VendingDetail />} />
                    <Route path="vending/register" element={<VendingRegister />} />
                    <Route path="vending/mapping" element={<StoreSelection />} />
                    <Route path="vending/mapping/:storeId" element={<VendingMapping />} />

                    <Route path="partners/register" element={<PartnersRegister />} />


                    <Route path="brand" >
                        <Route path="register" element={<BrandRegistration />} />
                        <Route path="list" element={<BrandList />} />
                        <Route path="list/:detail" element={<BrandListDetail />} />
                    </Route>
                    <Route path="exhibition">
                        <Route path="register" element={<ExhibitionRegistration />} />
                        <Route path="list" element={<ExhibitionList />} />
                    </Route>
                    <Route path="iot">
                        <Route path="home" element={<AdminIot />} />
                    </Route>
                    <Route path="cctv">
                        <Route path="home" element={<CCTVMonitor />} />
                    </Route>
                    {/* {renderNavItems(ManagerSideBarNavData)} */}
                    {/* <Route path="order" element={<DummyLayout />} >
                        <Route path="all" element={<DummyLayout />} />
                        <Route path="beforeDeposit" element={<DummyLayout />} />
                        <Route path="readyForShipping" element={<DummyLayout />} />
                        <Route path="waitingForShipping" element={<DummyLayout />} />
                        <Route path="shipping" element={<DummyLayout />} />
                        <Route path="shippingComplete" element={<DummyLayout />} />
                        <Route path="cancelBeforeDeposit" element={<DummyLayout />} />
                        <Route path="cancel" element={<DummyLayout />} />
                        <Route path="exchange" element={<DummyLayout />} />
                        <Route path="return" element={<DummyLayout />} />
                        <Route path="refund" element={<DummyLayout />} />
                        <Route path="cardCancel" element={<DummyLayout />} />
                        <Route path="adminRefund" element={<DummyLayout />} />
                    </Route>
                    <Route path="order" element={<DummyLayout />} >
                        <Route path="all" element={<DummyLayout />} />
                        <Route path="beforeDeposit" element={<DummyLayout />} />
                        <Route path="readyForShipping" element={<DummyLayout />} />
                        <Route path="waitingForShipping" element={<DummyLayout />} />
                        <Route path="shipping" element={<DummyLayout />} />
                        <Route path="shippingComplete" element={<DummyLayout />} />
                        <Route path="cancelBeforeDeposit" element={<DummyLayout />} />
                        <Route path="cancel" element={<DummyLayout />} />
                        <Route path="exchange" element={<DummyLayout />} />
                        <Route path="return" element={<DummyLayout />} />
                        <Route path="refund" element={<DummyLayout />} />
                        <Route path="cardCancel" element={<DummyLayout />} />
                        <Route path="adminRefund" element={<DummyLayout />} />
                        <Route path="autoDeposit" element={<DummyLayout />} />
                        <Route path="autoDepositProcess" element={<DummyLayout />} />
                        <Route path="cashReceiptDetail" element={<DummyLayout />} />
                        <Route path="reqTaxInvoice" element={<DummyLayout />} />
                        <Route path="taxInvoiceDetail" element={<DummyLayout />} />
                        <Route path="nonReqTaxInvoice" element={<DummyLayout />} />
                    </Route>
                    <Route path="product">
                        <Route path="" />
                        <Route path="list" element={<DummyLayout />} />
                        <Route path="simpleRegister" element={<DummyLayout />} />
                        <Route path="register" element={<ManagerRegisterPage type={"Product"} storeId={storeId} />} />
                        <Route path="collectiveChange" element={<DummyLayout />} />
                        <Route path="excel" element={<DummyLayout />} />
                        <Route path="deletedList" element={<DummyLayout />} />
                        <Route path="category" element={<DummyLayout />} />
                        <Route path="promotion" element={<DummyLayout />} />
                        <Route path="display" element={<DummyLayout />} />
                        <Route path="autoDisplay" element={<DummyLayout />} />
                        <Route path="mainGalleryDisplay" element={<DummyLayout />} />
                        <Route path="mainDisplay" element={<ManagerRegisterPage type={"Exhibition"} storeId={storeId} />} />
                        <Route path="categoryDisplay" element={<DummyLayout />} />
                        <Route path="displayReservation" element={<DummyLayout />} />
                        <Route path="restock" element={<DummyLayout />} />
                        <Route path="soldout" element={<DummyLayout />} />
                        <Route path="safetyRestock" element={<DummyLayout />} />
                        <Route path="creationItemOption" element={<ManagerRegisterPage type={"ProductOption"} storeId={storeId} />} />
                        <Route path="creationItemOptionSet" element={<ManagerRegisterPage type={"ProductSetOption"} storeId={storeId} />} />
                        <Route path="interlockingOption" element={<ManagerRegisterPage type={"ProductOption"} storeId={storeId} />} />
                        <Route path="interlockingOptionSet" element={<ManagerRegisterPage type={"ProductSetOption"} storeId={storeId} />} />
                    </Route>
                    <Route path="member" element={<DummyLayout />}>
                        <Route path="info" element={<DummyLayout />} />
                        <Route path="order" element={<DummyLayout />} />
                        <Route path="highestAmount" element={<DummyLayout />} />
                        <Route path="grade" element={<DummyLayout />} />
                        <Route path="excel" element={<DummyLayout />} />
                        <Route path="certificate" element={<DummyLayout />} />
                        <Route path="withdrawal" element={<DummyLayout />} />
                        <Route path="dormant" element={<DummyLayout />} />
                        <Route path="signInManagement" element={<DummyLayout />} />
                        <Route path="negativeSignIn" element={<DummyLayout />} />
                    </Route>
                    <Route path="board" >
                        <Route path="management" element={<DummyLayout />} />
                        <Route path="urgentInquiry" element={<DummyLayout />} />
                        <Route path="operationalLog" element={<DummyLayout />} />
                        <Route path="calendar" element={<DummyLayout />} />
                        <Route path="inHouseBulletinBoard" element={<DummyLayout />} />

                    </Route>
                    <Route path="promotion" element={<DummyLayout />} >
                        <Route path="service" element={<DummyLayout />} />
                        <Route path="benefit" element={<DummyLayout />} />
                        <Route path="benefitManagement" element={<DummyLayout />} />
                        <Route path="coupon" element={<DummyLayout />} />
                        <Route path="couponCreate" element={<DummyLayout />} />
                        <Route path="reqCouponAndInquiry" element={<DummyLayout />} />
                        <Route path="cerealCouponCreate" element={<DummyLayout />} />
                        <Route path="reqCerealAndInquiry" element={<DummyLayout />} />
                        <Route path="sales" element={<DummyLayout />} />
                        <Route path="salesCode" element={<DummyLayout />} />
                        <Route path="attendanceCheckService" element={<DummyLayout />} />
                        <Route path="attendanceCheckCreate" element={<DummyLayout />} />
                        <Route path="attendanceCheck" element={<DummyLayout />} />
                        <Route path="userInfoEventService" element={<DummyLayout />} />
                        <Route path="userInfoEventCreate" element={<DummyLayout />} />
                        <Route path="userInfoEvent" element={<DummyLayout />} />
                        <Route path="rewards" element={<DummyLayout />} />
                        <Route path="recommendedRecruitment" element={<DummyLayout />} />
                        <Route path="recommended" element={<DummyLayout />} />
                        <Route path="commonEvent" element={<DummyLayout />} />
                        <Route path="bridge" element={<DummyLayout />} />
                        <Route path="bridgeEntryAndWinner" element={<DummyLayout />} />
                        <Route path="bridgeServiceEffect" element={<DummyLayout />} />
                        <Route path="onlineSurvey" element={<DummyLayout />} />
                    </Route>
                    <Route path="statistics" element={<DummyLayout />} >
                        <Route path="todaySales" element={<DummyLayout />} />
                        <Route path="weekSales" element={<DummyLayout />} />
                        <Route path="monthSales" element={<DummyLayout />} />
                        <Route path="byPayment" element={<DummyLayout />} />
                        <Route path="bySalesProfit" element={<DummyLayout />} />
                        <Route path="multShoppingmall" element={<DummyLayout />} />
                        <Route path="salesProduct" element={<DummyLayout />} />
                        <Route path="category" element={<DummyLayout />} />
                        <Route path="cancelAndReturn" element={<DummyLayout />} />
                        <Route path="supplier" element={<DummyLayout />} />
                        <Route path="brand" element={<DummyLayout />} />
                        <Route path="cart" element={<DummyLayout />} />
                        <Route path="cartDetail" element={<DummyLayout />} />
                        <Route path="wishList" element={<DummyLayout />} />
                        <Route path="dayOfTheWeek" element={<DummyLayout />} />
                        <Route path="time" element={<DummyLayout />} />
                        <Route path="grade" element={<DummyLayout />} />
                        <Route path="region" element={<DummyLayout />} />
                        <Route path="reserveAndReservationFund" element={<DummyLayout />} />
                        <Route path="vendorSales" element={<DummyLayout />} />
                    </Route>
                    <Route path="excel" element={<DummyLayout />} >
                        <Route path="orderInfo" element={<DummyLayout />} />
                        <Route path="product" element={<DummyLayout />} />
                        <Route path="member" element={<DummyLayout />} />
                        <Route path="article" element={<DummyLayout />} />
                        <Route path="promotion" element={<DummyLayout />} />
                        <Route path="down/orderInfo" element={<DummyLayout />} />
                        <Route path="down/product" element={<DummyLayout />} />
                        <Route path="down/member" element={<DummyLayout />} />
                        <Route path="down/article" element={<DummyLayout />} />
                        <Route path="down/promotion" element={<DummyLayout />} />
                        <Route path="form/orderInfo" element={<DummyLayout />} />
                        <Route path="form/product" element={<DummyLayout />} />
                        <Route path="form/member" element={<DummyLayout />} />
                        <Route path="form/article" element={<DummyLayout />} />
                        <Route path="form/promotion" element={<DummyLayout />} />
                    </Route>
                    <Route path="setting" element={<DummyLayout />} >
                        <Route path="order" element={<DummyLayout />} />
                        <Route path="afterOrder" element={<DummyLayout />} />
                        <Route path="orderStatus" element={<DummyLayout />} />
                        <Route path="orderForm" element={<DummyLayout />} />
                        <Route path="product" element={<DummyLayout />} />
                        <Route path="productInfo" element={<DummyLayout />} />
                        <Route path="productList" element={<DummyLayout />} />
                        <Route path="supplierSales" element={<DummyLayout />} />
                        <Route path="vendor" element={<DummyLayout />} />
                        <Route path="brand" element={<DummyLayout />} />
                        <Route path="member" element={<DummyLayout />} />
                        <Route path="memberGrade" element={<DummyLayout />} />
                        <Route path="meberReserves" element={<DummyLayout />} />
                        <Route path="memberBalance" element={<DummyLayout />} />
                        <Route path="signUpCategory" element={<DummyLayout />} />
                        <Route path="article" element={<DummyLayout />} />
                        <Route path="faq" element={<DummyLayout />} />
                        <Route path="shopAndSecurity" element={<DummyLayout />} />
                        <Route path="shoppingmall" element={<DummyLayout />} />
                        <Route path="myShop" element={<DummyLayout />} />
                        <Route path="seo" element={<DummyLayout />} />
                        <Route path="termsOfUse" element={<DummyLayout />} />
                        <Route path="passwordChange" element={<DummyLayout />} />
                        <Route path="paymentType" element={<DummyLayout />} />
                        <Route path="backAccount" element={<DummyLayout />} />
                        <Route path="paymentFee" element={<DummyLayout />} />
                        <Route path="taxInvoice" element={<DummyLayout />} />
                        <Route path="cashReceipt" element={<DummyLayout />} />
                        <Route path="deliveryFee" element={<DummyLayout />} />
                        <Route path="deliveryCompany" element={<DummyLayout />} />
                        <Route path="adminAccount" element={<DummyLayout />} />
                        <Route path="business" element={<DummyLayout />} />
                        <Route path="supplierAccount" element={<DummyLayout />} />
                        <Route path="supplier" element={<DummyLayout />} />
                        <Route path="supplierShopManagement" element={<DummyLayout />} />
                        <Route path="signInSecurity" element={<DummyLayout />} />

                    </Route> */}
                </Route>
            </Route>
        </Routes>
    );
}
export default AdminRouter;
